import { useCallback, useEffect, useRef, useState } from 'react'

const DURACION_TOAST_MS = 4000

/**
 * Estado de un toast que se cierra solo. Un mensaje nuevo reinicia el tiempo
 * en lugar de dejar que el timer del anterior lo cierre antes de tiempo.
 */
export const useToast = () => {
  const [toast, setToast] = useState(null)
  const timerRef = useRef(null)

  const cerrarToast = useCallback(() => {
    clearTimeout(timerRef.current)
    setToast(null)
  }, [])

  const mostrarMensaje = useCallback((variant, message) => {
    clearTimeout(timerRef.current)
    setToast({ variant, message })
    timerRef.current = setTimeout(() => setToast(null), DURACION_TOAST_MS)
  }, [])

  useEffect(() => () => clearTimeout(timerRef.current), [])

  return { toast, mostrarMensaje, cerrarToast }
}
